import config from '../../config';
import { getAuthHeaders, handleResponse } from './common';

/**
 * Business Associate Agreement — org-scoped endpoints.
 * POST /organizations/{organizationReferenceId}/baa
 * GET  /organizations/{organizationReferenceId}/baa/status
 */
const baaApi = {
  /**
   * @param {string} organizationReferenceId
   * @param {{
   *   resignExistingAgreement?: boolean,
   *   practiceLegalName: string,
   *   signatoryName: string,
   *   signatoryTitle?: string | null,
   *   signature: { type: 'typed'; name: string } | { type: 'drawn'; dataUrl: string }
   * }} body
   * @returns {Promise<object>} Parsed JSON on 201, or { conflict: true, data } on 409
   */
  submitBaa: async (organizationReferenceId, body) => {
    const res = await fetch(
      `${config.api.url}/organizations/${encodeURIComponent(organizationReferenceId)}/baa`,
      {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify(body),
      }
    );

    if (res.status === 409) {
      let data = null;
      try {
        const ct = res.headers.get('content-type');
        if (ct && ct.includes('application/json')) {
          data = await res.json();
        }
      } catch {
        /* ignore */
      }
      return { conflict: true, data };
    }

    return handleResponse(res);
  },

  getBaaStatus: async (organizationReferenceId) => {
    const res = await fetch(
      `${config.api.url}/organizations/${encodeURIComponent(organizationReferenceId)}/baa/status`,
      { headers: getAuthHeaders() }
    );
    return handleResponse(res);
  },
};

export default baaApi;
